// removed by extract-text-webpack-plugin
module.exports = {"readonly-input-class":"_2J2udnlT6DMj7Itq8Gw4jE_0","el-textarea__inner":"_1aTEbJ3OJyZeN4ddLBnX9T_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a88ca68","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/config/group/netdevice/components/popup/PolicyDetailInfoPopup.vue
// module id = Jkuz
// module chunks = 75